<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-else>
            <v-row>
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">รายละเอียดนำสินค้าเข้าคลัง</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()"
                            large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>

            <section class="mt-10">
                <div class="ma-5">
                    <v-card elevation="4" class="pa-3 card_relative">
                        <div class="tag_header_profile d-flex">
                            <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                <div class="logo_timeline mx-auto my-auto">
                                    <img src="@/assets/arin_assets/ordericon.png">
                                </div>
                            </div>
                            <v-card elevation="3" class="card_title ml-n5">
                                <div class="arin-text-color py-1 pl-8 pr-5">ข้อมูลใบสั่งซื้อ</div>
                            </v-card>
                        </div>
                        <v-row class="pa-4">
                            <v-col  cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                                <div class=" text_title">เลขที่ใบอ้างอิง/ No : <span
                                        class="text_detail">{{ reference.order_code }}</span>
                                </div>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                                <div class=" text_title">เลขที่ใบเสร็จ/ใบ CN : <span class="text_detail">{{reference.receipt_no}}</span>
                                </div>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                                <div class=" text_title">ภาษีการซื้อ : <span class="text_detail">{{(reference.vat_type == 0) ? 'ภาษีรวมใน' : (reference.vat_type == 1) ? 'ภาษีแยกนอก' : (reference.vat_type == 2) ? 'ไม่มีภาษี' : (reference.vat_type == 2) ? 'ภาษีเป็น 0' : '-'}}</span></div>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                                <div class=" text_title">ชื่อ บริษัท/Supplier Name : <span class="text_detail">{{reference.supplier_name}}</span>
                                </div>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                                <div class=" text_title">วันที่ใบเสร็จ : <span class="text_detail">{{reference.receipt_date}}</span>
                                </div>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
                                <div class=" text_title">ประเภท : <span class="text_detail">{{(reference.is_credit == 0) ? 'เงินสด' : (reference.is_credit == 1) ? 'เครดิต' :'-' }}</span></div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <div class="content-header-title">รายการสินค้า</div>
                            </v-col>
                            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                <v-simple-table fixed-header height="410px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-center" style="font-size:14px;">ลำดับ</th>
                                                <th class="" style="font-size:14px;">รายการสินค้า</th>
                                                <th style="font-size:14px;">ล็อต</th>
                                                <th style="font-size:14px;">วันที่หมดอายุ</th>
                                                <th style="font-size:14px;">หน่วยนับ</th>
                                                <th class="text-center" style="font-size:14px;">จำนวนที่ได้รับ</th>
                                                <th class="text-center" style="font-size:14px;">ราคาต่อหน่วย</th>
                                                <th class="text-center" style="font-size:14px;">ส่วนลด (บาท)</th>
                                                <th class="text-center" style="font-size:14px;">ส่วนลด (%)</th>
                                                <th class="text-right" style="font-size:14px;">ราคารวม</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="product">
                                            <tr v-for="(item, i) in product" :key="item.id">
                                                <td class="text-center hidden_line">{{ i+1 }}</td>
                                                <td class="text-left hidden_line">{{ item.product_name != null ? item.product_name : '-' }}</td>
                                                <td class="hidden_line">{{ item.lot_no }}</td>
                                                <td class="hidden_line">
                                                  วันที่หมดอายุ {{ item.date_expired.split(" ")[0] }}
                                                </td>

                                                <td class="hidden_line">{{ item.unit_name }}</td>
                                                <td class="text-center hidden_line">{{
                                                    item.quantity
                                                }}</td>
                                                <td class="text-center hidden_line">{{
                                                    formatPrice(item.cost)
                                                }}</td>
                                                <td class="text-center hidden_line">{{
                                                    formatPrice(item.discount_amount || 0)
                                                }}</td>
                                                <td class="text-center hidden_line">{{
                                                    formatPrice(item.discount_percent || 0)
                                                }}</td>
                                                <td class="text-right hidden_line">{{ formatPrice(item.price) }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                            <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                <div class="d-flex" style="justify-content:space-between">
                                    <h3>รวม</h3>
                                    <h3>{{formatPrice(total)}}</h3>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                            <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                            <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                <div class="d-flex" style="justify-content:space-between">
                                    <p style="font-size:16px;">ส่วนลดท้ายบิล</p>
                                    <p style="font-size:16px;">{{ formatPrice(reference.discount) }}</p>
                                </div>
                            </v-col>
                            <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                            <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                <div class="d-flex" style="justify-content:space-between">
                                    <p style="font-size:16px;">ราคาสินค้าไม่รวมภาษี</p>
                                    <p style="font-size:16px;">{{ formatPrice(total_dis) }}</p>
                                </div>
                            </v-col>
                            <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                            <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                <div class="d-flex" style="justify-content:space-between">
                                    <p style="font-size:16px;">ภาษีมูลค่าเพิ่ม 7%</p>
                                    <p style="font-size:16px;">{{ formatPrice(vat) }}</p>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                            <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                <div class="d-flex" style="justify-content:space-between">
                                    <h3>จำนวนเงินทั้งสิ้นรวมภาษี</h3>
                                    <h3>{{ formatPrice(net) }}</h3>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
            </section>




            <!-- <v-card elevation="4" style="border-radius: 15px;">
                <v-card-text>
                    <div class="mt-3 pa-4">
                        <v-form ref="setting">
                            <v-row>
                                <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="8">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/ordericon.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลใบสั่งซื้อ</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="4">
                                    <div class="d-flex justify-end">
                                        <v-switch v-model="ref" color="#86bc3a" inset></v-switch>
                                        <div class="mt-1∂" style="font-size:16px;">อ้างอิงเลขที่เอกสารในระบบ</div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบอ้างอิง/ No. <span
                                                class="required--text">*</span></label>
                                        <v-autocomplete color="#D6BFAF" class="input-radius" :items="reference"
                                            prepend-inner-icon="mdi-file-document" item-text="reference_name"
                                            item-value="id" hide-details="auto"
                                            placeholder="กรุณาเลือกเลขที่ใบอ้างอิง/ No." single-line outlined
                                            :rules="[v => !!v || 'กรุณาเลือกข้อมูล']" dense></v-autocomplete>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบเสร็จ/ใบ CN <span
                                                class="required--text">*</span></label>
                                        <v-text-field color="#D6BFAF" class="input-radius"
                                            prepend-inner-icon="mdi-file-document" hide-details="auto" single-line
                                            placeholder="ชื่อ บริษัท/Supplier Name" value="vs014451" outlined dense
                                            disabled></v-text-field>
                                    </v-form-group>
                                </v-col>

                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ภาษีการซื้อ <span
                                                class="required--text">*</span></label>
                                        <v-radio-group row>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีรวมใน"
                                                color="#D6BFAF" :value="0" disabled></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีแยกนอก"
                                                color="#D6BFAF" :value="1" disabled></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ไม่มีภาษี"
                                                color="#D6BFAF" :value="2" disabled></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีเป็น 0"
                                                color="#D6BFAF" :value="3" disabled></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อ บริษัท/Supplier Name <span
                                                class="required--text">*</span></label>
                                        <p>บริษัท ฟาร์มาแคร์ พลัส จำกัด</p>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">วันที่ใบเสร็จ <span
                                                class="required--text">*</span></label>
                                        <v-text-field color="#D6BFAF" class="input-radius"
                                            prepend-inner-icon="mdi-calendar" hide-details="auto" single-line
                                            value="11/10/2022" outlined dense disabled></v-text-field>
                                    </v-form-group>
                                </v-col>

                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ประเภท <span
                                                class="required--text">*</span></label>
                                        <v-radio-group row>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="เงินสด"
                                                color="#D6BFAF" :value="0"></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="เครดิต"
                                                color="#D6BFAF" :value="1"></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/cycle.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">รายการสินค้า</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="6" md="9" lg="9" xl="9" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">สินค้า <span
                                                class="required--text">*</span></label>
                                        <v-autocomplete color="#D6BFAF" class="input-radius" :items="product"
                                            item-text="product" item-value="id" hide-details="auto"
                                            placeholder="กรุณาเลือกสินค้า" single-line outlined
                                            :rules="[v => !!v || 'กรุณาเลือกข้อมูล']" dense></v-autocomplete>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <label class="label_form_text">หน่วยนับ <span
                                            class="required--text">*</span></label>
                                    <v-autocomplete class="input-radius" color="#D6BFAF" :items="unit_list"
                                        :rules="[v => !!v || 'กรุณาเลือกข้อมูล']" item-text="name" item-value="id"
                                        placeholder="กรุณาเลือกหน่วยนับ" hide-details="auto" single-line outlined
                                        dense />
                                </v-col>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-simple-table fixed-header height="410px">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-center">ลำดับ</th>
                                                    <th class="text-center">รหัสสินค้า</th>
                                                    <th>ล็อต</th>
                                                    <th>รายการสินค้า</th>
                                                    <th>หน่วยนับ</th>
                                                    <th class="text-center">จำนวนที่ได้รับ</th>
                                                    <th class="text-center">ราคาต่อหน่วย</th>
                                                    <th class="text-right">ราคารวม</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in product" :key="item.id">
                                                    <td class="text-center hidden_line">{{ item.id }}</td>
                                                    <td class="text-center hidden_line">{{ item.code }}</td>
                                                    <td class="hidden_line">{{ item.lot }}</td>
                                                    <td class="hidden_line">
                                                        {{ item.product }}<br>วันที่หมดอายุ {{ item.exp }}
                                                    </td>

                                                    <td class="hidden_line">{{ item.unit }}</td>
                                                    <td class="text-center hidden_line">{{
                                                        item.qty
                                                    }}<br>ส่วนลด(บาท) {{ item.discount_price }} บาท</td>
                                                    <td class="text-center hidden_line">{{
                                                        item.unit_price
                                                    }}<br>ส่วนลด(%) {{ item.discount_percen }}บาท</td>
                                                    <td class="text-right hidden_line">{{ item.total_price }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-row>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>รวม</h3>
                                            <h3>21,381.00</h3>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <p style="font-size:16px;">ส่วนลดท้ายบิล</p>
                                            <p style="font-size:16px;">0.00</p>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <p style="font-size:16px;">ราคาสินค้าไม่รวมภาษี</p>
                                            <p style="font-size:16px;">21,381.00</p>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <p style="font-size:16px;">ภาษีมูลค่าเพิ่ม 7%</p>
                                            <p style="font-size:16px;">1,496.67</p>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>จำนวนเงินทั้งสิ้นรวมภาษี</h3>
                                            <h3>22,877.67</h3>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>

                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="title_page ma-3" style="justify-content:center;">
                                        <v-btn type="submit" class="btn_add_data_submit" elevation="4"
                                            large>บันทึก</v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-form>
                    </div>
                </v-card-text>
            </v-card> -->
        </div>
    </div>
</template>

<script>
import { isTelephone, taxNumber, validateEmail, onPaste, minDate, formatPrice } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_inventory_list",
    data() {
        return {
            id: this.$route.params.id,
            loading_page: false,
            search: '',
            tab_id: null,
            inventory_remove: false,
            price_new: false,
            dateRangeText: null,
            ref: true,
            menu_date: false,
            menu_date_exp: false,
            date_exp: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateEN: '',
            dateEXP: '',
            start_date: this.min_date(),
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            sub_menu: [
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'เพิ่มสินค้าเข้าคลัง',
                    disabled: false,
                    href: '#',
                },
            ],
            headers: [
                {
                    text: 'รหัสสินค้า',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'ชื่อสินค้า',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'จำนวน',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'หน่วยนับ',
                    value: 'product_code',
                    fixed: true,
                },
                {
                    text: 'จัดการ',
                    value: '',
                    fixed: true,
                    sortable: false,
                },
            ],
            reference: [],
            product: [],
            unit_list: [
                { id: 1, name: 'Box(O)' },
                { id: 2, name: 'Box(100)' },
                { id: 3, name: 'table(23)' },
            ],
            data_list: [],
            total: 0,
            total_dis: 0,
            discount: 0,
            vat: 0,
            net: 0,
        }
    },
    methods: {
        formatPrice(number){
            return formatPrice(number)
        },
        link(link) {
            window.location.href = link;
        },
        inventory_remove_dialog() {
            this.inventory_remove = true;
        },
        price_new_dialog() {
            this.price_new = true;
        },
        tabs(number) {
            this.tab_id = number
            if (number === 1) {
                this.data_list = [
                    {
                        id: 1,
                        promotion_code: 'ANB0015',
                        promotion_name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
                        qty: '49',
                        unit_name: 'Ampule',
                    },
                    {
                        id: 2,
                        promotion_code: 'BER3029',
                        promotion_name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
                        qty: '49',
                        unit_name: 'แผง',
                    },
                    {
                        id: 3,
                        promotion_code: 'PRO-007',
                        promotion_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
                        qty: '20',
                        unit_name: 'ขวด',
                    },
                    {
                        id: 4,
                        promotion_code: 'PRO-008',
                        promotion_name: 'ยาดม IZE JELLI BALM 7 G 29.-',
                        qty: '30',
                        unit_name: 'ขวด',
                    },
                    {
                        id: 5,
                        promotion_code: '2M1205',
                        promotion_name: 'cr.SUPIROCIN OINT 5G 95.-',
                        qty: '5',
                        unit_name: 'หลอด',
                    },
                ]
            } else if (number === 2) {
                this.data_list = [
                    {
                        id: 1,
                        promotion_code: 'BB0004',
                        promotion_name: 'Bananaboat Aloe Vera Gel 90 ml 152.-',
                        qty: '49',
                        unit_name: 'หลอด',
                        status: true,
                    },
                ]
            }
        },
        isNumber: function (evt, number) {
            return isTelephone(evt, number)
        },
        isTaxNumber: function (evt, number) {
            return taxNumber(evt, number)
        },
        isEmail: function (evt) {
            return validateEmail(evt)
        },
        isPaste: function (evt) {
            return onPaste(evt)
        },
        min_date: function () {
            return minDate()
        },
        async selectDate() {
            this.$refs.menu_date.save(this.date)
            this.menu_date = false
        },
        DateEXP_TH(value) {
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0]) + 543
            const final_date = day + '/' + month + '/' + year
            return this.date_exp = final_date
        },
        diffDateTH(value) {
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0]) + 543
            const final_date = day + '/' + month + '/' + year
            return this.date = final_date
        },
        diffDateEN() {
            const diff = this.date.split('-')
            const year = parseInt(diff[2]) - 543
            const month = diff[1]
            const day = diff[0]
            return year + '-' + month + '-' + day
        },
        computed: {
            dateRangeText() {
                return this.dates.join(' ~ ')
            },
        },
        async  getImportHistory_detail(){
        let id = this.id;
        this.loading_page = true;
        this.product = []
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        await HTTP_ARIN.get('/pos/import/detail/'+ id, config).then((res) => {
            if (res.data.successful === true) {
                
            this.product = res.data.data.import_list;

            this.reference = res.data.data.import;
            this.discount = this.reference.discount
            this.sumTotal()
            this.loading_page = false;
            }
        })
        },
         sumTotal(){
              this.total = 0;
              let total = 0;
                for (let i = 0; i < this.product.length; i++) {
                    switch(this.reference.vat_type){
                           case 0 : 
                                 total += parseFloat(this.product[i].price);
                                 this.total = total
                                this.total_dis = ((this.total  - this.discount) * (100/107));
                                this.vat = (total - this.discount) - ((total - this.discount) * (100/107));
                                this.net = this.total_dis + this.vat;
                            break;
                            case 1 : 
                                 total += parseFloat(this.product[i].price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = this.total_dis * (7 / 100);
                                this.net = this.total_dis + this.vat;
                            break;
                            case 2 : 
                                 total += parseFloat(this.product[i].price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = null;
                                this.net = this.total_dis;
                            break;
                            case 3 : 
                                 total += parseFloat(this.product[i].price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = 0;
                                this.net = this.total_dis;
                            break;
                        }
                }
        },
    },
    mounted() {
        this.getImportHistory_detail();
        this.tabs(1)
    }
}
</script>

<style scoped>
.card_relative {
    position: relative;
    border-radius: 15px;
}

.profile_detail {
    display: grid;
    grid-template-columns: 30% 70%;
}

.header_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.logo_timeline {
    width: 25px;
    height: 25px;
    padding: 0px;
}

.logo_timeline>img {
    max-width: 25px;
}

.tag_header_profile {
    position: absolute;
    top: -30px;
    left: -15px;
}

.arin-text-color {
    color: #84611F;
    font-weight: bold;
    font-size: 16px;
}

.arin-text-color-two {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.card_title {
    margin-top: 1px;
    margin-bottom: 1px;
    border-radius: 10px;
    border: 1px solid #D6BFAF;
}

.preview {
    border-radius: 10px;
}

.employee_box {
    border-radius: 10px;
    border: 1px solid #D6BFAF;
    width: auto;
}

.sub_title {
    font-size: 16px;
}

.image_title {
    font-weight: 500;
    font-size: 16px;
}

.picture_details {
    display: grid;
    grid-template-columns: 40% 60%;
}

.mobile_btn {
    width: 40%;
}

.grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.grid_four_ck {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
}

.text_title {
    color: #909090;
    font-weight: bold;
    font-size: 16px;
}

.text_detail {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}
</style>
